import ValidationErrors from '../entity/ValidationErrors';
import { ApiValidationError } from '../entity/ApiValidationError';

export default class ValidationErrorUtils {
  public static mapErrors(errors: ApiValidationError[]): ValidationErrors {
    return errors.reduce((result, { propertyPath, message }) => ({ ...result, [propertyPath]: message }), {});
  }
}
